import { gql } from '@apollo/client';

export const SAVE_PARTNER_BALANCE_SHEET = gql`
  mutation savePartnerBalanceSheet($input: PartnerBalanceSheetInput) {
    savePartnerBalanceSheet(input: $input) {
      balanceSheet {
        balanceSheetId
        partnerId
        configId
        dimensionYear
        dimensionMonth
        localName
        currencyId
        currencyRate
        finalizationTypeId
        balanceSheetTypeId
      }
    }
  }
`;

export const REMOVE_PARTNER_BALANCE_SHEET = gql`
  mutation removePartnerBalanceSheet($balanceSheetId: Int) {
    removePartnerBalanceSheet(balanceSheetId: $balanceSheetId) {
      balanceSheetId
    }
  }
`;

export const SAVE_PARTNER_BALANCE_SHEET_DETAIL = gql`
  mutation savePartnerBalanceSheetDetail($input: PartnerBalanceSheetDetailInput) {
    savePartnerBalanceSheetDetail(input: $input) {
      detail {
        balanceSheetDetailId
        balanceSheetId
        configDetailId
        creditCurrencyAmount
        debitCurrencyAmount
        eqCreditAmount
        eqDebitAmount
      }
      indicators {
        balanceSheetIndicatorId
        balanceSheetId
        indicatorId
        indicatorValue
      }
    }
  }
`;

export const SAVE_PARTNER_BALANCE_SHEET_INDICATORS = gql`
  mutation savePartnerBalanceSheetIndicators($input: [PartnerBalanceSheetIndicatorInput]) {
    savePartnerBalanceSheetIndicators(input: $input) {
      indicators {
        balanceSheetIndicatorId
        balanceSheetId
        indicatorId
        indicatorValue
      }
    }
  }
`;